import { gql } from '@apollo/client';

export const getBusinessPartnerPlanList = gql`
  query getBusinessPartnerPlanList(
    $pagination: PaginationInput!
    $selectedBusinessPartnerID: String
    $selectedBusinessPartnerLineID: [String]
    $Attribute: String!
    $Descending: Boolean!
    $keywordSearch: String
  ) {
    SalesforceManagement {
      queries {
        getBusinessPartnerPlanList(
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          selectedBusinessPartnerLineID: $selectedBusinessPartnerLineID
          pagination: $pagination
          OrderBy: { Attribute: $Attribute, Descending: $Descending }
          KeywordSearch: $keywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            salesforceManagement_BusinessPartnerPlan_Id

            salesforceManagement_BusinessPartnerPlan_BusinessPartnerID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }

            salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                    LineCommissionType
                    LineCommissionValue
                    ValueCurrency {
                      Id
                      Code
                      Title
                    }
                    LineCommissionRate
                    ApplicableOn {
                      Id
                      Code
                      Title
                    }
                  }
                }
              }
            }

            line_ExternalCode
            line_Name
            line_Status
            plan_ExternalCode
            plan_Name
            plan_PlanStatus

            salesforceManagement_BusinessPartnerPlan_PlanCommissionType
            salesforceManagement_BusinessPartnerPlan_PlanCommissionValue
            salesforceManagement_BusinessPartnerPlan_ValueCurrency {
              Code
              Title
              Symbol
            }
            salesforceManagement_BusinessPartnerPlan_PlanCommissionRate

            salesforceManagement_BusinessPartnerPlan_ApplicableOn {
              Code
              Title
            }
            salesforceManagement_BusinessPartnerPlan_ActiveFrom
            salesforceManagement_BusinessPartnerPlan_ActiveTo
            salesforceManagement_BusinessPartnerPlan_Status
            salesforceManagement_BusinessPartnerPlan_LineID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                    Status
                  }
                }
              }
            }
            salesforceManagement_BusinessPartnerPlan_PlanID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                    ExternalCode
                    PlanStatus
                    SpecialCommissionApplicable
                    SpecialCommissionType
                    SpecialCommissionValue
                    SpecialCommissionValueCurrency {
                      Id
                      Code
                      Title
                    }
                    SpecialCommissionRate
                    SpecialCommissionApplicableOn {
                      Id
                      Code
                      Title
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    SalesforceManagement_BusinessPartnerStatuses: __type(
      name: "SalesforceManagement_BusinessPartnerStatuses"
    ) {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getBPLinesLov = gql`
  query getBPLinesLov($selectedBusinessPartnerID: String) {
    SalesforceManagement {
      queries {
        getBusinessPartnerLinesListWithoutPagination(
          selectedBusinessPartnerID: $selectedBusinessPartnerID
        ) {
          salesforceManagement_BusinessPartnerLine_Id
          salesforceManagement_BusinessPartnerLine_LineID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const activateBusinessPartnerPlan = gql`
  mutation activateBusinessPartnerPlan(
    $entityId: String!
    $selectedBusinessPartnerPlanIds: [String!]!
  ) {
    salesforceManagement {
      entities {
        businessPartner {
          salesforceManagement {
            activateBusinessPartnerPlan(
              entityId: $entityId
              selectedBusinessPartnerPlanIds: $selectedBusinessPartnerPlanIds
            )
          }
        }
      }
    }
  }
`;

export const deactivateBusinessPartnerPlan = gql`
  mutation deactivateBusinessPartnerPlan(
    $entityId: String!
    $selectedBusinessPartnerPlanIds: [String!]!
  ) {
    salesforceManagement {
      entities {
        businessPartner {
          salesforceManagement {
            deactivateBusinessPartnerPlan(
              entityId: $entityId
              selectedBusinessPartnerPlanIds: $selectedBusinessPartnerPlanIds
            )
          }
        }
      }
    }
  }
`;
